import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

import Button from '../../common/button';

import { colours, fontSize, spacing } from '../../../theme';

import { JOBSBOARD_TITLE, CONTACT_TITLE } from '../../../constants/titles';

const Container = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const Box = styled.div`
  background-color: ${colours.black};
  width: 10em;
  padding: ${spacing.small} ${spacing.medium};
  margin: ${spacing.massive} 0;
`;

const P = styled.p`
  margin: 0;
  font-size: ${fontSize.small};
  color: ${colours.white};
  text-align: center;
`;

const Success = ({ setTitle }) => {

  setTitle(CONTACT_TITLE);

  return (
    <Container>
      <Box>
        <P>Thank you!</P>
        <P>Your message has been sent.</P>
      </Box>
      <NavLink to="/"><Button label="Back" onClick={() => setTitle(JOBSBOARD_TITLE)} /></NavLink>
    </Container>
  );
};

export default Success;
